import React from 'react'
import { CSSTransition } from 'react-transition-group'

import styles from './SlideFade.module.less'

type Props = {
    children: React.ReactNode,
    unmountOnExit?: boolean,
    in: boolean,
}

export default function SlideFade (props: Props) {
    const nodeRef = React.useRef(null);

    return (
        <CSSTransition
            {...props}
            timeout={250}
            classNames={{ ...styles }}
            nodeRef={nodeRef}
        >
            <div className={styles.baseClass} ref={nodeRef}>
                {props.children}
            </div>
        </CSSTransition>
    )
}
